import React, { useContext } from "react";

import { AppContext } from "App";
import supportImage from "assets/images/profile/support.png";
import { useNavigate } from "react-router-dom";

const BookingConfirmation: React.FC = () => {
    const { isMobile } = useContext(AppContext);
    const navigate = useNavigate();
    return (
        <div className="p20 mWidth600 mAuto">
            <div className="w100 taCenter">
                <img
                    src={supportImage}
                    alt="Booking Confirmed"
                    className="mlAuto"
                    width={300}
                />
            </div>

            <h1 className={`${isMobile ? "" : "taCenter"}`}>Your booking has been confirmed!</h1>
            <p className="taLeft">Thank you for choosing to book an appointment with one of our accountants. Please check your email to find details of the booking.</p>
            <button
                className="shared__secondary-button mt20 mlAuto mrAuto"
                onClick={() => navigate("/profile")}
            >
                Go to Home
            </button>
            <p className="mt20 taCenter">If you have any questions, please contact us at <a href="mailto:support@taxzap.co.uk">support@taxzap.co.uk</a>.</p>
        </div>
    );
};

export default BookingConfirmation;
